export const messageHistoryCopyIt = {
    title: "Cronologia dei messaggi",
    noMessages: "Nessun messaggio trovato",
    viewMessages: "Vedi i messaggi",
    to: "A:",
    from: "Da:",
    subject: "Oggetto:",
    statusClicked: "Cliccato",
    statusRead: "Letto",
    statusReadAt: "alle",
    statusDelivered: "Consegnato",
    statusSent: "Inviato",
    statusPending: "In attesa",
    channelEmail: "E-mail",
    channelSms: "SMS",
    retentionNotice: "I messaggi vengono conservati solo per 30 giorni",
};
